import styles from './RunningOrderStatus.module.scss';

import { useNavigate } from '@reach/router';
import { useRunningOrder } from 'hooks/context/RunningOrder';
import { useServiceType } from 'hooks/context/serviceType';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RouteFC } from 'util/routeTypes';
import { ThreePartLayout } from './Layout/ThreePartLayout/ThreePartLayout';
import { LineItems } from './LineItems/LineItems';
import { ModalKitModal } from './ModalKit/ModalKitModal/ModalKitModal';
import { VisualHeaderLayout } from './ModalKit/VisualHeaderLayout/VisualHeaderLayout';
import Typography from './Typography/Typography';
import { StackedCtaLayout } from './ModalKit/Cta/StackedCtaLayout';
import CtaItem from './ModalKit/Cta/CtaItem';
import { RUNNING_ORDER_STATUS } from './RunningOrderStatus.const';

/**
  * Shows your complete running order, gives you the option
  * to closeout or add more items
 */
export const RunningOrderStatus: RouteFC = ({ location }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tableDetails } = useServiceType();
  const runningOrder = useRunningOrder();

  return (
    <ModalKitModal
      aria={{ labelledby: RUNNING_ORDER_STATUS.id }}
      isOpen={true}
      onClose={() => navigate('checkout')}
      testId={RUNNING_ORDER_STATUS.id}
    >
      <ThreePartLayout className={styles.layout}>
        <ThreePartLayout.Header>
          <VisualHeaderLayout
            id={RUNNING_ORDER_STATUS.id}
            className={styles.header}
            iconName={'shoppingbag'} iconSize={64}>
            <VisualHeaderLayout.Title>
              <Typography.Heading1>{t('hoorah')}</Typography.Heading1>
            </VisualHeaderLayout.Title>

            <VisualHeaderLayout.Subtitle>
              <Typography.Body>{t('success.dine_in_table_message', { tableNumber: tableDetails?.name })}</Typography.Body>
            </VisualHeaderLayout.Subtitle>

          </VisualHeaderLayout>
        </ThreePartLayout.Header>

        <ThreePartLayout.Main>
          <LineItems className={styles.lineItems} items={runningOrder.items} readOnly={true} />
        </ThreePartLayout.Main>

        <ThreePartLayout.Footer>
          <StackedCtaLayout className={styles.footer}>

              <CtaItem.Primary onClick={() => navigate('~menu')} data-testid={RUNNING_ORDER_STATUS.addMore}>
                {t('scan2order.addMore')}
              </CtaItem.Primary>

              <CtaItem.Secondary onClick={() => navigate('checkout')} data-testid={RUNNING_ORDER_STATUS.closeOut}>
                {t('scan2order.closeOut')}
              </CtaItem.Secondary>
          </StackedCtaLayout>
        </ThreePartLayout.Footer>
      </ThreePartLayout>
    </ModalKitModal>
  );
};
